export default __webpack_public_path__ + "static/media/work-details-outline-16px.190f5439.svg";